<template>
    <div class="back-top">
        <div class="flex__center__center menu__top" v-show="show">
            <span class="jcicon jcicon-dingbu fs_40 c_main"></span>
        </div>
        <div class="flex__center__center menu__bottom" v-link="url">
            <span class="jcicon jcicon-shouye fs_50 c_ff"></span>
        </div>
    </div>
</template>
<script>
export default {
    name: "BackTop",
    props: {
        url:{
            type: String
        },
        show:{
            type: Boolean
        }
    }
}
</script>
<style scoped>
.back-top{
    position: fixed;
    right: 10px;
    bottom: 140px;
}
.menu__top{
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #fff;
    box-shadow:0px 5px 13px 0px rgba(191,191,191,0.5);
}
.menu__bottom{
    width: 80px;
    height: 80px;
    margin-top: 20px;
    border-radius: 50%;
    background: rgba(0,0,0,0.6);
    box-shadow:0px 5px 13px 0px rgba(191,191,191,0.5);
}
</style>




// WEBPACK FOOTER //
// src/components/hzjc/back-top/Index.vue